export default __webpack_public_path__ + "static/media/logo.894d8bfc.svg";